import React from 'react';
import PropTypes from 'prop-types';
import { LANG_ENG } from '../constants/RailsLandingSeoConstants';
import { getAppEnv } from '../../../../config/env';
import '../../../styles/RISIconPalette.css';

const HOME_PAGE = 'https://makemytrip.com';

const LandingHeader = (props) => {
  const handleBackClick = () => {
    window.open(HOME_PAGE, '_self');
  };
  const env = getAppEnv();
  const { PUBLIC_URL } = env.raw;
  return (
    <div className="railsLandingHeader">
      <div className="railSeoSprite backIcon" onClick={handleBackClick} />
      <h1 className="font16">{props.trainHeaderTitle}</h1>
      <div className="railsLanguageSwitcher" onClick={props.onClick}>
        <img className="langSwitchImage" src={`${PUBLIC_URL}/static/public/languageSwitcher.webp`} alt={''} />
        <span>{props?.lang === LANG_ENG ? 'हिंदी' : LANG_ENG.toLocaleUpperCase()}</span>
      </div>
    </div>
  );
};

LandingHeader.propTypes = {
  onClick: PropTypes.func,
  trainHeaderTitle: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired
};

export default LandingHeader;
